import QueryString from '../../lib/QueryString';

// see https://gitlab.com/pivotdev/crossover/snippets/1855465
export function createLineupsExplorerQueryString(
  seasonId,
  gameId,
  filter,
  players,
) {
  const query = new QueryString();

  if (players) {
    const playersOn = [];
    const playersOff = [];
    Object.keys(players.active).forEach(id => {
      const value = players.active[id];
      if (value === 'on') playersOn.push(id);
      else if (value === 'off') playersOff.push(id);
    });
    query.addArray('players_on', playersOn);
    query.addArray('players_off', playersOff);
  }

  if (gameId) {
    query.addValue('games', gameId);
  }
  if (filter) {
    if (filter.period && filter.period.value) {
      query.addArray('periods', filter.period.value.map(x => x.value));
    }

    const lastTwoMinutesValue =
      filter.lastTwoMinutes && filter.lastTwoMinutes.value;
    if (lastTwoMinutesValue === 'last2') {
      query.addBoolean('is_final_two', true);
    } else if (lastTwoMinutesValue === 'standard') {
      query.addBoolean('is_final_two', false);
    }

    const rotationValue = filter.rotation && filter.rotation.value;
    if (rotationValue === 'starter') {
      query.addBoolean('is_starting', true);
    } else if (rotationValue === 'rotation') {
      query.addBoolean('is_starting', false);
    }

    if (filter.clutchGarbage && filter.clutchGarbage.value) {
      filter.clutchGarbage.value.map(({ value }) =>
        query.addBoolean(value, true),
      );
    }

    if (filter.totalTime && filter.totalTime.value) {
      query.addRange('minutes', filter.totalTime.value, filter.totalTime.range);
    }

    if (filter.totalPoints && filter.totalPoints.value) {
      query.addRange(
        'plus_minus',
        filter.totalPoints.value,
        filter.totalPoints.range,
      );
    }

    const validHomeAwayValues = ['home', 'away', 'visitor'];
    if (filter.homeAway && filter.homeAway.value) {
      if (validHomeAwayValues.includes(filter.homeAway.value)) {
        query.addValue('side', filter.homeAway.value);
      }
    }

    const validConferenceValues = ['in', 'out'];
    if (filter.conference && filter.conference.value) {
      if (validConferenceValues.includes(filter.conference.value)) {
        query.addValue('conference', filter.conference.value);
      }
    }

    const validDivisionValues = ['in', 'out'];
    if (filter.division && filter.division.value) {
      if (validDivisionValues.includes(filter.division.value)) {
        query.addValue('division', filter.division.value);
      }
    }
  }
  query.addValue('season_id', seasonId);

  return query.toString();
}
